import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronUp, ChevronDown, GripVertical } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const clean = (s) => (s.title || s.essay_title || s.key || "").replace(/\*/g, "");

export const SectionOrder = ({ kit, reload }) => {
  const [list, setList] = useState(kit.sections);
  const [drag, setDrag] = useState(null);
  useEffect(() => setList(kit.sections), [kit.sections]);

  const persist = async (next) => {
    setList(next);
    try {
      await http.put(`/kits/${kit.id}/order`, { keys: next.map((s) => s.key) });
      toast.success("Section order saved");
      reload();
    } catch (e) { toast.error(errMsg(e)); setList(kit.sections); }
  };
  const move = (from, to) => {
    if (to < 0 || to >= list.length || from === to) return;
    const next = [...list];
    const [x] = next.splice(from, 1);
    next.splice(to, 0, x);
    persist(next);
  };

  return (
    <div data-testid="section-order-list" className="space-y-0.5">
      {list.map((s, i) => (
        <div key={s.key} data-testid={`order-item-${s.key}`} draggable
          onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()}
          onDrop={() => { move(drag, i); setDrag(null); }} onDragEnd={() => setDrag(null)}
          className={`group flex items-center gap-1 rounded-sm px-1 py-0.5 transition-colors ${drag === i ? "bg-[#C9A847]/15" : "hover:bg-stone-100"}`}>
          <GripVertical size={13} className="text-stone-300 cursor-grab shrink-0" />
          <a href={`#sec-${s.key}`} className="flex-1 text-sm text-stone-500 hover:text-stone-900 py-1 truncate">{clean(s)}</a>
          <button data-testid={`order-up-${s.key}`} onClick={() => move(i, i - 1)} disabled={i === 0} title="Move up" className="p-0.5 text-stone-400 hover:text-stone-900 disabled:opacity-20"><ChevronUp size={14} /></button>
          <button data-testid={`order-down-${s.key}`} onClick={() => move(i, i + 1)} disabled={i === list.length - 1} title="Move down" className="p-0.5 text-stone-400 hover:text-stone-900 disabled:opacity-20"><ChevronDown size={14} /></button>
        </div>
      ))}
    </div>
  );
};
